import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CART} from '@optimaxdev/analytics/mobile/constants/events/cart';
import {sendMobileAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

type ActionType = 'shippingAddress changed' | 'shippingOptions changed' | 'place order';
type LabelType = 'PayPal' | 'Google Pay' | 'Google Pay Express' | 'Apple Pay' | 'Apple Pay Express';
/**
 * callbackWithAnalyticsEvent
 */
export const callbackWithAnalyticsEvent = async <T>(
    action: ActionType,
    label: LabelType,
    callback: () => Promise<T>,
) => {
    const func =
        __BUILD_TYPE__ === 'desktop' ? sendDesktopAnalyticsEvent : sendMobileAnalyticsEvent;
    try {
        const result = await callback();
        spawnPriorityTask(() => {
            func(CART.CTA, {
                action: `${label} ${action}`,
                label,
            });
        });

        return result;
    } catch (error) {
        spawnPriorityTask(() => {
            const [currentError] = error?.response?.data?.messages?.error || [
                {message: 'Something went wrong. Try again later.'},
            ];
            func(CART.CTA, {
                action: `${label} ${action}. Error: ${currentError.message}`,
                label,
            });
        });

        return error;
    }
};
